export const MEDIA_CONFIG = {
  ALLOWED_BUCKETS: [
    process.env.AWS_S3_BUCKET || 'fb-swoop-media',
    'swoop_media',
    'fbc_media_private',
    'fbc_media',
    'fbc_events_private', 
    'fbc_events_public',
    'fbc_brands_private',
    'fbc_forms',
    'event-images'
  ] as const,
  
  MAX_WIDTH: 2500,
  MAX_HEIGHT: 2500,
  MIN_QUALITY: 20,
  MAX_QUALITY: 100,
  DEFAULT_QUALITY: 80,
  
  CACHE_TTL: 300, // 5 minutes
  STALE_WHILE_REVALIDATE: 600, // 10 minutes
  
  ALLOWED_FORMATS: ['jpg', 'jpeg', 'png', 'webp', 'gif'] as const,
  ALLOWED_FIT_MODES: ['cover', 'contain', 'fill'] as const,
} as const

export type AllowedBucket = typeof MEDIA_CONFIG.ALLOWED_BUCKETS[number]
export type AllowedFormat = typeof MEDIA_CONFIG.ALLOWED_FORMATS[number]
export type FitMode = typeof MEDIA_CONFIG.ALLOWED_FIT_MODES[number]